import React, { useState, useEffect } from "react";

// --- Formulário para adicionar/editar corretora ---
function CorretoraForm({ onSuccess, onCancel, corretora }) {
  // Se corretora existir, preenche com ela (modo edição); senão, form vazio (modo novo)
  const [form, setForm] = useState(() => corretora ? {
    cnpj_corretora: corretora.cnpj_corretora || "",
    nome_corretora: corretora.nome_corretora || "",
    cpf_usuario: corretora.cpf_usuario || "",
    responsavel: corretora.responsavel || "",
    email: corretora.email || "",
    telefone: corretora.telefone || "",
    senha: "",
    ativo: corretora.ativo ? 1 : 0,
  } : {
    cnpj_corretora: "",
    nome_corretora: "",
    cpf_usuario: "",
    responsavel: "",
    email: "",
    telefone: "",
    senha: "",
    ativo: 1,
  });
  const [mensagem, setMensagem] = useState("");

  // Atualiza form se mudar corretora selecionada (edição)
  useEffect(() => {
    if (corretora) {
      setForm({
        cnpj_corretora: corretora.cnpj_corretora || "",
        nome_corretora: corretora.nome_corretora || "",
        cpf_usuario: corretora.cpf_usuario || "",
        responsavel: corretora.responsavel || "",
        email: corretora.email || "",
        telefone: corretora.telefone || "",
        senha: "",
        ativo: corretora.ativo ? 1 : 0,
      });
    } else {
      setForm({
        cnpj_corretora: "",
        nome_corretora: "",
        cpf_usuario: "",
        responsavel: "",
        email: "",
        telefone: "",
        senha: "",
        ativo: 1,
      });
    }
  }, [corretora]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleAtivoToggle = () => {
    setForm(f => ({ ...f, ativo: f.ativo ? 0 : 1 }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setMensagem("");
    if (!form.cnpj_corretora || !form.nome_corretora || !form.responsavel || !form.cpf_usuario || (!corretora && !form.senha)) {
      setMensagem("Preencha todos os campos obrigatórios.");
      return;
    }
    try {
      const isEdit = !!corretora;
      const url = isEdit
        ? `https://gerencial.vionia.com.br/api/corretoras/${form.cnpj_corretora}`
        : "https://gerencial.vionia.com.br/api/corretora_add";
      const method = isEdit ? "PUT" : "POST";
      // Só manda senha se for cadastro OU o usuário digitou nova senha
      const payload = { ...form };
      if (isEdit && !payload.senha) delete payload.senha;
      const resp = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (resp.ok) {
        setMensagem("Corretora salva com sucesso!");
        setForm({
          cnpj_corretora: "",
          nome_corretora: "",
          cpf_usuario: "",
          responsavel: "",
          email: "",
          telefone: "",
          senha: "",
          ativo: 1,
        });
        if (onSuccess) onSuccess();
      } else {
        const data = await resp.json();
        setMensagem(data.detail || "Erro ao salvar corretora.");
      }
    } catch {
      setMensagem("Erro de conexão com o servidor.");
    }
  };

  const inputStyle = {
    width: "100%",
    border: "1.5px solid #d3d7e0",
    borderRadius: 12,
    padding: "10px 14px",
    fontSize: 16,
    color: "#555",
    background: "#f8fafd",
    marginBottom: 16,
    outline: "none",
    transition: "border 0.2s",
  };
  const labelStyle = {
    fontWeight: 500,
    fontSize: 15,
    color: "#888",
    marginBottom: 3,
    display: "block",
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        background: "#fff",
        borderRadius: 18,
        padding: 28,
        maxWidth: 430,
        margin: "30px auto",
        boxShadow: "0 6px 32px 0 rgba(44,62,80,.07)",
        fontFamily: "Inter, Arial, sans-serif"
      }}
    >
      <h3 style={{ marginTop: 0, marginBottom: 18, color: "#353535", fontWeight: 700 }}>
        {corretora ? "Editar Corretora" : "Nova Corretora"}
      </h3>
      <div>
        <label style={labelStyle}>CNPJ *</label>
        <input
          name="cnpj_corretora"
          value={form.cnpj_corretora}
          onChange={handleChange}
          required
          maxLength={18}
          style={inputStyle}
          placeholder="CNPJ"
          disabled={!!corretora} // Não deixa editar o CNPJ (chave primária)
        />
      </div>
      <div>
        <label style={labelStyle}>Corretora*</label>
        <input
          name="nome_corretora"
          value={form.nome_corretora}
          onChange={handleChange}
          required
          style={inputStyle}
          placeholder="Nome Corretora"
        />
      </div>
      <div>
        <label style={labelStyle}>CPF do responsável *</label>
        <input
          name="cpf_usuario"
          value={form.cpf_usuario}
          onChange={handleChange}
          required
          maxLength={14}
          style={inputStyle}
          placeholder="Apenas números"
        />
      </div>
      <div>
        <label style={labelStyle}>Responsável *</label>
        <input
          name="responsavel"
          value={form.responsavel}
          onChange={handleChange}
          required
          style={inputStyle}
          placeholder="Nome do responsável"
        />
      </div>
      <div>
        <label style={labelStyle}>Telefone</label>
        <input
          name="telefone"
          value={form.telefone}
          onChange={handleChange}
          maxLength={15}
          style={inputStyle}
          placeholder="(11) 98888-7766"
        />
      </div>
      <div>
        <label style={labelStyle}>Email</label>
        <input
          name="email"
          value={form.email}
          onChange={handleChange}
          type="email"
          style={inputStyle}
          placeholder="corretora@email.com"
        />
      </div>
      <div>
        <label style={labelStyle}>Senha *</label>
        <input
          name="senha"
          type="password"
          value={form.senha}
          onChange={handleChange}
          required={!corretora}
          style={inputStyle}
          placeholder={corretora ? "Deixe em branco para não alterar" : "Defina a senha"}
        />
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={{ ...labelStyle, marginRight: 12, display: "inline-block" }}>
          Ativo
        </label>
        <input
          type="checkbox"
          checked={!!form.ativo}
          onChange={handleAtivoToggle}
          style={{
            marginLeft: 8,
            width: 22, height: 22,
            borderRadius: 8, accentColor: "#00bcd4", verticalAlign: "middle"
          }}
        />
      </div>
      {mensagem && (
        <div style={{ color: mensagem.includes("sucesso") ? "#13b66b" : "#e04d4d", marginBottom: 14 }}>
          {mensagem}
        </div>
      )}
      <div style={{ display: "flex", gap: 16 }}>
        <button type="submit" style={{
          flex: 1,
          background: "#00bcd4",
          color: "#fff",
          border: 0,
          borderRadius: 13,
          padding: 13,
          fontWeight: 700,
          fontSize: 16,
          boxShadow: "0 2px 8px 0 rgba(0,188,212,0.07)",
          cursor: "pointer",
          transition: "background 0.2s"
        }}>
          Salvar
        </button>
        <button type="button" onClick={onCancel} style={{
          flex: 1,
          background: "#f4f5fa",
          color: "#888",
          border: 0,
          borderRadius: 13,
          padding: 13,
          fontWeight: 600,
          fontSize: 16,
          cursor: "pointer",
        }}>
          Cancelar
        </button>
      </div>
    </form>
  );
}

export default CorretoraForm;
